/**
 * CorporateCredentials — /corporate/credentials
 */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import client from "@/api/client";
import ClimateCredentialsPanel from "@/components/ClimateCredentialsPanel";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, SectionCard, CTAButton } from "@/components/ds";

export default function CorporateCredentials() {
  const navigate = useNavigate();
  const { currentOrg } = useAuth();
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  const load = () => {
    setLoading(true);
    client.get("/credentials/corporate")
      .then(r => { setData(r.data); setError(null); })
      .catch(e => setError(e))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="p-6 lg:p-8 space-y-6">
      <PageHeader
        label="CORPORATE WORKSPACE"
        title="Climate & Circularity Credentials"
        subtitle={`${currentOrg?.name || ""} · 7-section institutional document — GHG Protocol + IFRS S2 aligned`}
        backUrl="/corporate"
        backLabel="Corporate Workspace"
      />

      {error ? (
        <SectionCard>
          <div className="py-10 text-center">
            <p className="text-sm font-semibold text-amber-700">Credentials not yet available</p>
            <p className="text-xs text-slate-500 mt-1 mb-4">Calculate monthly data first.</p>
            <CTAButton variant="action" onClick={() => navigate("/corporate/monthly/inputs")}>
              Enter Monthly Data →
            </CTAButton>
          </div>
        </SectionCard>
      ) : (
        <ClimateCredentialsPanel data={data} loading={loading} onRefresh={load}
          workspace="corporate" periodLabel={data?.period} />
      )}
    </div>
  );
}
